export default "assets/images/icons/courrier-bb56df82.svg";